import { render, staticRenderFns } from "./EnterNamePhone.vue?vue&type=template&id=0c3041ca&"
import script from "./EnterNamePhone.vue?vue&type=script&lang=js&"
export * from "./EnterNamePhone.vue?vue&type=script&lang=js&"
import style0 from "./EnterNamePhone.vue?vue&type=style&index=0&id=0c3041ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports